// extracted by mini-css-extract-plugin
module.exports = {"compactWrapper":"ReceiverLocationSelector_compactWrapper__2QpTp","receiverLocation":"ReceiverLocationSelector_receiverLocation__3AOri"};